import React from 'react';

import QuestionCircleOutline from '@/components/commons/icons/QuestionCircleOutline';

import BioHelpLink from './BioHelpLink';
import RoundLabel from './RoundLabel';

function SectionHeader({
    number,
    headerText,
    subText,
    customWidth,
    textColor = '',
    showLink = false,
    onLinkClick = null,
}) {
    return (
        <div className="flex flex-wrap gap-3 justify-between items-center">
            <div>
                <div className="flex gap-2 items-center justify-start pb-4">
                    <RoundLabel number={number} />
                    <p className={`font-instrument text-base font-semibold leading-150 ${textColor} sm:min-w-[360px]`}>{headerText}</p>
                </div>
                <div className={customWidth || ''}>
                    <p
                        className={`w-full font-instrument text-sm font-normal leading-150 ${textColor}`}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: subText }}
                    />
                </div>
            </div>
            {showLink
                && (
                    <div>
                        <BioHelpLink
                            text="How do I add my signature to my email?"
                            icon={<QuestionCircleOutline className="w-4 h-4 float-left mr-[2px] text-progressBarBlue" />}
                            onClick={onLinkClick}
                        />
                    </div>
                )}
        </div>
    );
}

export default SectionHeader;
